import React, { useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useStoreActions } from 'easy-peasy';

const AuthenticationScreen = () => {
	const history = useHistory();
	const location = useLocation();
	const { status, data } = useParams();
	const setProfileDetail = useStoreActions((actions) => actions.template.setProfileDetail);

	useEffect(() => {
		console.log('AuthenticationScreen', location, status, data);
		if (status === 'success') {
			const decodedBase64 = atob(decodeURIComponent(data));
			const [jwt, id, email, firstName, lastName, profileImageUrl] =
				JSON.parse(decodedBase64);
			console.log(jwt, id, email, firstName, lastName, profileImageUrl);
			setProfileDetail({ jwt, id, email, firstName, lastName, profileImageUrl });

			history.push('/editor');
		}
	}, []);

	return <div>AuthenticationScreen</div>;
};

AuthenticationScreen.propTypes = {};

export default AuthenticationScreen;
